<script setup lang="ts">
import IconBase from '../IconBase.vue';
</script>

<template>
  <IconBase>
    <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M2 9.99994V5.99994C2 5.44765 2.44772 4.99994 3 4.99994H5.99732L8.78243 2.21296C9.22964 1.76546 9.99464 2.08218 9.99464 2.71484V13.285C9.99464 13.9177 9.22964 14.2344 8.78243 13.7869L5.99732 10.9999H3C2.44772 10.9999 2 10.5522 2 9.99994ZM11.9609 5.78433C12.218 5.68368 12.5081 5.81056 12.6087 6.0677C13.1047 7.33487 13.1047 8.66501 12.6087 9.93217C12.5081 10.1893 12.218 10.3162 11.9609 10.2155C11.7037 10.1149 11.5769 9.82485 11.6775 9.5677C12.0817 8.53487 12.0817 7.46501 11.6775 6.43217C11.5769 6.17502 11.7037 5.88497 11.9609 5.78433ZM14.0562 4.50158C13.919 4.26191 13.6135 4.17882 13.3739 4.31598C13.1342 4.45315 13.0511 4.75863 13.1883 4.9983C14.2732 6.89397 14.2706 9.10523 13.1879 11.0021C13.051 11.2419 13.1344 11.5473 13.3742 11.6842C13.6141 11.8211 13.9194 11.7376 14.0563 11.4978C15.3139 9.29465 15.3177 6.7059 14.0562 4.50158Z"
        fill="currentColor"
      />
    </svg>
  </IconBase>
</template>
